import React from "react";
import { Col, Card, Rate } from "antd";

const OnboardTestimonial = () => {
  const testimonialData = [
    {
      review:
        "I was initially skeptical, but Copilotly genuinely streamlined my daily routine. It's like having a second brain!",
      stars: 5,
      name: "Aria Mitchell",
      title: "Digital Marketing Specialist",
      link: "https://chrome.google.com/webstore/detail/copilotly-your-personal-a/fnpfnkfggchkcaheehdgmdapnomokajo",
    },
    {
      review:
        "Never thought I'd rely so much on an AI tool. It's been a game-changer for my writing projects.",
      stars: 5,
      name: "Liam Turner",
      title: "Content Strategist",
      link: "https://chrome.google.com/webstore/detail/copilotly-your-personal-a/fnpfnkfggchkcaheehdgmdapnomokajo",
    },
    {
      review:
        "From research to drafting emails, Copilotly has saved me countless hours. Highly recommended!",
      stars: 6,
      name: "Carlos Rodriguez",
      title: "Business Analyst",
      link: "https://chrome.google.com/webstore/detail/copilotly-your-personal-a/fnpfnkfggchkcaheehdgmdapnomokajo",
    },
    {
      review:
        "I've tried numerous tools, but Copilotly stands out. It understands my needs like no other.",
      stars: 6,
      name: "Priya Kapoor",
      title: "UX Designer",
      link: "https://chrome.google.com/webstore/detail/copilotly-your-personal-a/fnpfnkfggchkcaheehdgmdapnomokajo",
    },
    {
      review:
        "The best thing? It learns from you! Over time, Copilotly has become more attuned to my style and preferences.",
      stars: 5,
      name: "Grace O'Malley",
      title: "Project Manager",
      link: "https://chrome.google.com/webstore/detail/copilotly-your-personal-a/fnpfnkfggchkcaheehdgmdapnomokajo",
    },
    {
      review:
        "It's more than just a writing aid. It's my go-to for brainstorming, research, and even presentations.",
      stars: 5,
      name: "Samuel Chen",
      title: "Product Developer",
      link: "https://chrome.google.com/webstore/detail/copilotly-your-personal-a/fnpfnkfggchkcaheehdgmdapnomokajo",
    },
    {
      review:
        "The perfect companion for my diverse tasks. Whether it's data analysis or creative writing, Copilotly delivers.",
      stars: 6,
      name: "Zahra El-Sayed",
      title: "Data Scientist",
      link: "https://chrome.google.com/webstore/detail/copilotly-your-personal-a/fnpfnkfggchkcaheehdgmdapnomokajo",
    },
    {
      review:
        "A seamless blend of AI and human touch. It's transformed how I approach my tasks.",
      stars: 5,
      name: "Elijah Kim",
      title: "E-commerce Specialist",
      link: "https://chrome.google.com/webstore/detail/copilotly-your-personal-a/fnpfnkfggchkcaheehdgmdapnomokajo",
    },
  ];
  return (
    <>
      <h2 className="subscribe-heading">
        Still not sure? Hear from Those Who Took the Leap!
      </h2>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          justifyContent: "center",
          marginTop: "32px",
        }}
      >
        {testimonialData.map((testimonial, index) => (
          <Col key={index} xs={24} sm={12} md={8} lg={6}>
            <Card
              style={{
                width: "90%",
                minHeight: "100%",
                textAlign: "center",
                margin: "0 auto",
                backgroundColor: "#fff",
                border: "1px solid #E8E8E8",
                borderRadius: "8px",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
                cursor: "pointer",
              }}
              onClick={() => window.open(testimonial.link, "_blank")}
            >
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  marginBottom: "16px",
                  fontStyle: "italic",
                  minHeight: "100px",
                }}
              >
                "{testimonial.review}"
              </p>
              <Rate value={testimonial.stars} disabled />
              <h4>{testimonial.name}</h4>
              <p>{testimonial.title}</p>
            </Card>
          </Col>
        ))}
      </div>
    </>
  );
};

export default OnboardTestimonial;
